import { render } from "./beneficios.vue?vue&type=template&id=d1af593e"
import script from "./beneficios.vue?vue&type=script&lang=js"
export * from "./beneficios.vue?vue&type=script&lang=js"

import exportComponent from "/Users/desarrollo/Documents/Proyectos/friax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__